import React from "react";
import * as S from "./styles";
import Navbar from "../../components/Navbar";

export default function Home() {
  return (
    <>
      <Navbar />
    </>
  );
}
